import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./app/features/store/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./cvr";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <ToastContainer
      position="top-right"
      theme="colored"
      autoClose={3000}
      limit={5}
      style={{ width: "100%", maxWidth: "450px", margin: "2px 3px" }}
      pauseOnFocusLoss={false}
    />
    <Provider store={store}>
      <App />
    </Provider>
  </>
);
